import { SearchAutocompleteResponse } from '../../../types/SearchAutocomplete';
import request from '../request';

const getSearchAutocomplete = async ({ term, signal }: { term: string; signal?: AbortSignal }) => {
  const params = new URLSearchParams({ term, includeCities: 'true' });

  const response = await request<SearchAutocompleteResponse>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/hotels/search/autocomplete?${params.toString()}`,
    method: 'GET',
    signal,
  });
  return response;
};

export default getSearchAutocomplete;
